const months = [
  {
    id: 0,
    month: 'სექტემბერი',
    year: new Date().getFullYear(),
    payed: false,
    payedMoney: 0,
  },
  {
    id: 1,
    month: 'ოქტომბერი',
    year: new Date().getFullYear(),
    payed: false,
    payedMoney: 0,
  },
  {
    id: 2,
    month: 'ნოემბერი',
    year: new Date().getFullYear(),
    payed: false,
    payedMoney: 0,
  },
  {
    id: 3,
    month: 'დეკემბერი',
    year: new Date().getFullYear(),
    payed: false,
    payedMoney: 0,
  },
  {
    id: 4,
    month: 'იანვარი',
    year: new Date().getFullYear() + 1,
    payed: false,
    payedMoney: 0,
  },
  {
    id: 5,
    month: 'თებერვალი',
    year: new Date().getFullYear() + 1,
    payed: false,
    payedMoney: 0,
  },
  {
    id: 6,
    month: 'მარტი',
    year: new Date().getFullYear() + 1,
    payed: false,
    payedMoney: 0,
  },
  {
    id: 7,
    month: 'აპრილი',
    year: new Date().getFullYear() + 1,
    payed: false,
    payedMoney: 0,
  },
  {
    id: 8,
    month: 'მაისი',
    year: new Date().getFullYear() + 1,
    payed: false,
    payedMoney: 0,
  },
  {
    id: 9,
    month: 'ივნისი',
    year: new Date().getFullYear() + 1,
    payed: false,
    payedMoney: 0,
  },
]

export default months
